<div *ngIf="performanceCommentaryText; else defaultPerformanceCommentary" [innerHTML]="performanceCommentaryText"></div>
<ng-template #defaultPerformanceCommentary>
	<div dcrHTMLKey="PERFORMANCE_COMMENTARY_NOT_AVAILABLE">Performance commentary is not available for this model family</div>
</ng-template>
